import { ensureSafeComponent } from "@embroider/util";
import { importSync } from "@embroider/macros";

export default function (icon) {
  let module = importSync(`../components/icons/${icon}`);

  return ensureSafeComponent(module.default, this);
}
